import { useMutation } from '@tanstack/react-query'
import { billingApi } from '../../utils/api'

/**
 * 下位プランへの変更予約（BillingPage）。
 * 適用は次回更新日だが、予約中の表示はプラン情報から組み立てられるため、
 * 他の課金フックと同じく全体リロードで反映する（AuthContext を再取得しないと
 * 予約中の案内が出ない）。
 */
export function useDowngradeSubscription() {
  return useMutation({
    mutationFn: (planType: string) => billingApi.downgradeSubscription(planType),
    onSuccess: () => {
      window.location.reload()
    },
  })
}
